<template>
  <NuxtLayout>
    <OrganismsPagesEnError :error="props.error" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useBaseSentry } from '@/composables/utils/useSentry';
import { stateFactoryKey, useFetchFromPublicWabunkaApiKey, useFetchKey, useMicroCMSGetListKey, useRouteKey, useRouterKey, useRuntimeConfigKey, useSentryKey, useStateKey } from '@/injectionKeys';
import { useMicroCMSGetList } from '@/wabunka-src/common/composables/query/useMicroCMSClient';

provide(useRuntimeConfigKey, useRuntimeConfig);
provide(useFetchFromPublicWabunkaApiKey, useFetchFromPublicWabunkaApi);
provide(useRouterKey, useRouter);
provide(useRouteKey, useRoute);
provide(stateFactoryKey, stateFactory);
provide(useStateKey, useState);
provide(useSentryKey, useBaseSentry);
provide(useMicroCMSGetListKey, useMicroCMSGetList);
provide(useFetchKey, useFetch);

// eslint-disable-next-line vue/require-default-prop
const props = defineProps({ error: Object });
</script>

<style scoped lang="scss">
h1 {
  color: #333;
  font-family: Playfair Display;
  font-size: 124px;
  line-height: 165px;
  letter-spacing: 6px;
  text-align: center;
  margin-bottom: 24px;

  @apply md:mb-[38px] md:mt-[66px] md:text-[170px];
}

h2 {
  color: #333;
  font-family: Playfair Display;
  font-size: 28px;
  line-height: 18px;
  letter-spacing: 2px;
  text-align: center;
  margin-bottom: 16px;
}

hr {
  border: none;
  border-top: 1px solid #333;
  width: 120px;
  margin: 36px auto;
  @apply md:mx-auto md:my-[40px] md:w-[325px];
}
</style>
